import { render, staticRenderFns } from "./customer_count.vue?vue&type=template&id=25fb0648&scoped=true&"
import script from "./customer_count.vue?vue&type=script&lang=js&"
export * from "./customer_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb0648",
  null
  
)

export default component.exports